/* eslint-disable react-hooks/exhaustive-deps */
import { Button, makeStyles, Typography } from "@material-ui/core";
import { colours, theme } from "../constants/theme";
import downloadActive from "../assets/icons/download-active.svg";
import downloadInactive from "../assets/icons/download-inactive.svg";
import { buttonHoverAndActive } from "../utils/styles/buttonStyles";

export const InvoiceButtonSection = (props: any) => {
  const {
    downloadClicked,
    downloadDisabled,
    selectAllClicked,
    clearAllClicked,
  } = props;
  const classes = useStyles();

  return (
    <div className={classes.buttonContainer}>
      <div className={classes.buttonWrapper}>
        <Button onClick={selectAllClicked}>
          <Typography
            variant="button"
            component="span"
            style={{
              color: theme.palette.primary.main,
            }}
            onClick={props.onPrintLabelsClicked}
          >
            Select all
          </Typography>
        </Button>
      </div>
      <div className={classes.buttonWrapper}>
        <Button onClick={clearAllClicked} disabled={downloadDisabled}>
          <Typography
            variant="button"
            component="span"
            style={{
              color: !downloadDisabled
                ? theme.palette.primary.main
                : theme.palette.text.disabled,
            }}
            onClick={props.onPrintLabelsClicked}
          >
            Clear all
          </Typography>
        </Button>
      </div>
      {/* <div className={classes.buttonWrapper}>
        <Button className={classes.downloadButton}>
          <img
            src={downloadActive}
            className={classes.buttonIcon}
            alt="print icon"
          />

          <Typography
            variant="button"
            component="span"
            
            onClick={props.onPrintLabelsClicked}
          >
            Print
          </Typography>
        </Button>
      </div> */}
      <div className={classes.buttonWrapper}>
        <Button
          className={
            downloadDisabled
              ? classes.disabledDownloadButton
              : classes.downloadButton
          }
          disabled={downloadDisabled}
        >
          <img
            src={downloadDisabled ? downloadInactive : downloadActive}
            className={classes.buttonIcon}
            alt="download icon"
          />

          <Typography
            variant="button"
            component="span"
            style={{
              color: downloadDisabled
                ? theme.palette.text.disabled
                : colours.primary,
            }}
            onClick={downloadClicked}
          >
            Download
          </Typography>
        </Button>
      </div>
    </div>
  );
};
const useStyles = makeStyles({
  buttonContainer: {
    display: "flex",
    paddingTop: 24,
    paddingRight: 24,
    paddingBottom: 16,
    justifyContent: "flex-end",
  },
  buttonIcon: {
    width: "18px",
    height: "18px",
    marginRight: 8,
  },
  downloadButton: {
    minWidth: 64,
    height: 36,
    borderRadius: 8,
    paddingTop: "6px",
    paddingBottom: "6px",
    paddingRight: "16px",
    paddingLeft: "12px",
    ...buttonHoverAndActive
  },
  disabledDownloadButton: {
    minWidth: 64,
    height: 36,
    borderRadius: 8,
    paddingTop: "6px",
    paddingBottom: "6px",
    paddingRight: "16px",
    paddingLeft: "12px",
    backgroundColor: colours.highEmphasis16,
  },
  buttonWrapper: {
    marginLeft: "8px",
  },
});
